import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Form, Grid, Tab } from 'semantic-ui-react';
import { reduxForm, Field } from 'redux-form';
import moment from 'moment';
import _ from 'lodash';

import { createFieldsValidator } from 'Common/FormHelper';
import { RECIPE_PREPARATION_FILTERS_FORM_NAME } from 'Common/FormEnum';
import {
  GroupedRadioField,
  DatePickerField,
  Select,
} from 'Common/SemanticWrapper';
import { RecipePreparationFiltersEnum as Fields } from 'Common/FieldEnum';

import { TABS, MealTypeOptions, StatusOptions } from '../helpers';

const now = moment();

class FiltersForm extends Component {
  static propTypes = {
    activeIndex: PropTypes.number,
  };

  static defaultProps = {
    activeIndex: 0,
  };

  panes = [
    {
      menuItem: 'Recipe Group',
      render: () => {
        const { recipeGroupOptions } = this.props;
        return (
          <Tab.Pane>
            <Grid>
              <Grid.Row>
                <Grid.Column width={4}>
                  <Field
                    label={'Group'}
                    component={Select}
                    name={Fields.GroupId}
                    options={recipeGroupOptions}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Tab.Pane>
        );
      },
    },
    {
      menuItem: 'Cycle Menu',
      render: () => {
        const { cycleMenuOptions } = this.props;
        return (
          <Tab.Pane>
            <Grid>
              <Grid.Row>
                <Grid.Column width={8}>
                  <Field
                    label={'Cycle Menu'}
                    component={Select}
                    name={Fields.CycleMenuId}
                    options={cycleMenuOptions}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Tab.Pane>
        );
      },
    },
    {
      menuItem: 'Calendar Menu',
      render: () => {
        const { siteOptions } = this.props;
        return (
          <Tab.Pane>
            <Grid>
              <Grid.Row>
                <Grid.Column width={4}>
                  <Field
                    label={'Site'}
                    component={Select}
                    name={Fields.SiteId}
                    options={siteOptions}
                  />
                </Grid.Column>
                <Grid.Column width={4}>
                  <Field
                    label={'Meal Type'}
                    component={Select}
                    name={Fields.MealTypeId}
                    options={MealTypeOptions}
                  />
                </Grid.Column>
                <Grid.Column width={4}>
                  <Field
                    label={'Date'}
                    component={DatePickerField}
                    name={Fields.Date}
                    openToDate={now}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Tab.Pane>
        );
      },
    },
  ];

  onTabChange = (e, data) => {
    const { change, resetRecipeSearch } = this.props;
    change(Fields.Tab, data.activeIndex);
    resetRecipeSearch();
  };

  render() {
    const { activeIndex, handleSubmit } = this.props;
    return (
      <Form onSubmit={handleSubmit}>
        <Grid padded>
          <Grid.Row>
            <Grid.Column width={16}>
              <Tab
                activeIndex={activeIndex}
                onTabChange={this.onTabChange}
                panes={this.panes}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={16}>
              <div className="display--flex-center">
                <Field
                  label=""
                  component={GroupedRadioField}
                  name={Fields.Status}
                  horizontal
                  options={StatusOptions}
                />
              </div>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={16}>
              <div className="display--flex-center">
                <Button type="submit">Find Recipes</Button>
              </div>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Form>
    );
  }
}

const validators = {
  [TABS.RECIPE_GROUP]: createFieldsValidator([Fields.GroupId], null, {
    [Fields.GroupId]: value => !_.isNil(value),
  }),
  [TABS.CYCLE_MENU]: createFieldsValidator([Fields.CycleMenuId]),
  [TABS.CALENDAR_MENU]: createFieldsValidator(
    [Fields.Date, Fields.MealTypeId, Fields.SiteId],
    null,
    {
      [Fields.MealTypeId]: value => !_.isNil(value),
    }
  ),
};

const validate = (values, props) => {
  let errors = {};
  if (!_.isNil(props.activeIndex)) {
    const validator = validators[props.activeIndex];
    errors = validator(values);
  }
  return errors;
};

const RecipePreparationFilters = reduxForm({
  form: RECIPE_PREPARATION_FILTERS_FORM_NAME,
  validate,
})(FiltersForm);

export { RecipePreparationFilters };



// WEBPACK FOOTER //
// ./src/pages/recipepreparation/components/RecipePreparationFilters.js